import pressureUnits from 'config/pressure-units';
import { pressures, requiredPressure } from 'lib/capacity-calculations';
import { toSignificant } from 'lib/number';
import maxGraphDepth from 'lib/graph-depth';
import DepthGraph from 'components/graph/DepthGraph';

const requiredCompressionLabel = (project, loadIndex) => (
  `Required Pressure = ${toSignificant(requiredPressure(project, loadIndex), 3).toLocaleString()} PSI`
);

export default function PressureGraph({project={}, load, maxDim}) {
  const {data, settings: {lengthUnit}} = project;
  const loads = load ? [load] : data?.loads;
  const loadIndex = (id) => _.findIndex(data?.loads, {id});
  const pushPierLoads = _.filter(loads, {pileType: 'push_pier'});

  return (
    <DepthGraph
      loads={
        _.map(pushPierLoads, ({id, name, ram}) => ({
          id, name,
          data: pressures(project, loadIndex(id)),
          envelope: [pressures(project, loadIndex(id), -1), pressures(project, loadIndex(id), 1)],
          guides: {
            'Max Pressure': ram?.max_pressure_psi,
            [requiredCompressionLabel(project, loadIndex(id))]: requiredPressure(project, loadIndex(id))
          }
        }))
      }
      unitX={pressureUnits.psi}
      unitY={lengthUnit}
      maxDepth={maxGraphDepth({data: project.data})}
      baseScale="25"
      maxDim={maxDim} />
  );
}
